const mockCity = [
  {
    type: 'forecast',
    trend: 'Decreasing',
    date: '2024-02-01T00:00:00',
    createdAt: '2024-02-14T14:10:31.3577025',
    fixedRatio: 0.93,
    fixedRate: 12194.0,
    unfixedRate: 11255.0,
    currentCalculatedRate: 12126.93,
    previousCalculatedRate: 12728.21,
    payoutRatio: 100.0,
  },
  {
    type: 'forecast',
    trend: 'Increasing',
    date: '2024-03-01T00:00:00',
    createdAt: '2024-02-14T14:10:38.7186641',
    fixedRatio: 0.0,
    fixedRate: 0.0,
    unfixedRate: 11755.0,
    currentCalculatedRate: 11755.0,
    previousCalculatedRate: 11725.0,
    payoutRatio: 100.0,
  },
  {
    type: 'forecast',
    trend: 'Increasing',
    date: '2024-04-01T00:00:00',
    createdAt: '2024-02-14T14:11:34.4801883',
    fixedRatio: 0.0,
    fixedRate: 0.0,
    unfixedRate: 12255.0,
    currentCalculatedRate: 12255.0,
    previousCalculatedRate: 12225.0,
    payoutRatio: 100.0,
  },
]

const mrMock = [
  {
    type: 'forecast',
    trend: 'Increasing',
    date: '2024-02-01T00:00:00',
    createdAt: '2024-02-22T10:02:31.1123974',
    fixedRatio: 0.95,
    fixedRate: 33696.0,
    unfixedRate: 33298.0,
    currentCalculatedRate: 33674.89,
    previousCalculatedRate: 31854.41,
    payoutRatio: 100.0,
  },
  {
    type: 'forecast',
    trend: 'Increasing',
    date: '2024-03-01T00:00:00',
    createdAt: '2024-02-22T10:02:53.3227659',
    fixedRatio: 0.25,
    fixedRate: 39358.0,
    unfixedRate: 30647.0,
    currentCalculatedRate: 32839.85,
    previousCalculatedRate: 31710.04,
    payoutRatio: 100.0,
  },
  {
    type: 'forecast',
    trend: 'Increasing',
    date: '2024-04-01T00:00:00',
    createdAt: '2024-02-22T10:07:48.27026',
    fixedRatio: 0.02,
    fixedRate: 29892.0,
    unfixedRate: 34083.0,
    currentCalculatedRate: 33991.05,
    previousCalculatedRate: 31986.88,
    payoutRatio: 100.0,
  },
]

const lr1Mock = [
  {
    type: 'forecast',
    date: '2024-09-02T00:00:00.000Z',
    fixedRatio: 1,
    fixedRate: 22075,
    unfixedRate: 0,
    currentCalculatedRate: 22075,
  },
  {
    type: 'forecast',
    date: '2024-10-02T00:00:00.000Z',
    fixedRatio: 0.2,
    fixedRate: 21229,
    unfixedRate: 31053,
    currentCalculatedRate: 29088.2,
  },
  {
    type: 'forecast',
    date: '2024-11-02T00:00:00.000Z',
    fixedRatio: 0,
    fixedRate: 0,
    unfixedRate: 28000,
    currentCalculatedRate: 28000,
  },
]

const handyMock = [
  {
    type: 'forecast',
    trend: 'Decreasing',
    date: '2024-02-01T00:00:00',
    createdAt: '2024-02-22T10:02:31.0254381',
    fixedRatio: 0.9,
    fixedRate: 27296.0,
    unfixedRate: 27445.0,
    currentCalculatedRate: 27311.63,
    previousCalculatedRate: 27797.4,
    payoutRatio: 100.0,
  },
  {
    type: 'forecast',
    trend: 'Increasing',
    date: '2024-03-01T00:00:00',
    createdAt: '2024-02-22T10:02:53.3084827',
    fixedRatio: 0.28,
    fixedRate: 27009.0,
    unfixedRate: 27259.0,
    currentCalculatedRate: 27188.48,
    previousCalculatedRate: 27134.78,
    payoutRatio: 100.0,
  },
  {
    type: 'forecast',
    trend: 'Increasing',
    date: '2024-04-01T00:00:00',
    createdAt: '2024-02-22T10:07:48.261947',
    fixedRatio: 0.09,
    fixedRate: 27417.0,
    unfixedRate: 26790.0,
    currentCalculatedRate: 26843.39,
    previousCalculatedRate: 26619.01,
    payoutRatio: 100.0,
  },
]

const lr2Mock = [
  {
    date: '2024-04-02T00:00:00.000Z',
    createdAt: '2024-05-10T16:10:07.531Z',
    fixedRatio: 1,
    fixedRate: 33304,
    unfixedRate: 0,
    currentCalculatedRate: 33304,
    payoutRatio: 100,
    previousCalculatedRate: 31651,
    type: 'past',
    trend: 'Increasing',
  },
  {
    date: '2024-05-02T00:00:00.000Z',
    createdAt: '2024-06-14T07:28:28.465Z',
    fixedRatio: 1,
    fixedRate: 42925.92,
    unfixedRate: 0,
    currentCalculatedRate: 42925.92,
    payoutRatio: 100,
    previousCalculatedRate: 37398.69,
    type: 'past',
    trend: 'Increasing',
  },
  {
    date: '2024-06-02T00:00:00.000Z',
    createdAt: '2024-07-12T09:05:17.175Z',
    fixedRatio: 1,
    fixedRate: 62279.33,
    unfixedRate: 0,
    currentCalculatedRate: 62279.33,
    payoutRatio: 100,
    previousCalculatedRate: 64138,
    type: 'past',
    trend: 'Decreasing',
    comments: 'The rate decreased due to market conditions.',
  },
]

export const mockForecast = lr1Mock

const monthFromNow = (offset: number) => {
  const now = new Date()
  return new Date(
    Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + offset, 1),
  ).toISOString()
}

const chems2TrendsItem = {
  companyCode: 'CHEMS2',
  companyName: 'Chemicals 2',
  createdAt: monthFromNow(0),
}

export const mockForecastTrends = [
  {
    ...chems2TrendsItem,
    date: monthFromNow(-1),
    fixedRatio: 0.85,
    fixedRate: 22500,
    unfixedRate: 21000,
    fixedDays: 412,
    unfixedDays: 73,
    currentCalculatedRate: 22275,
    previousCalculatedRate: 21980,
    trend: 'Increasing',
    trendPercentage: 1,
  },
  {
    ...chems2TrendsItem,
    date: monthFromNow(0),
    fixedRatio: 0.42,
    fixedRate: 23100,
    unfixedRate: 22400,
    fixedDays: 197,
    unfixedDays: 273,
    currentCalculatedRate: 22694,
    previousCalculatedRate: 23050,
    trend: 'Decreasing',
    trendPercentage: -2,
  },
  {
    ...chems2TrendsItem,
    date: monthFromNow(1),
    fixedRatio: 0.08,
    fixedRate: 23800,
    unfixedRate: 23200,
    fixedDays: 39,
    unfixedDays: 446,
    currentCalculatedRate: 23248,
    previousCalculatedRate: 23000,
    trend: 'Increasing',
    trendPercentage: 1,
  },
  {
    ...chems2TrendsItem,
    date: monthFromNow(2),
    fixedRatio: 0,
    fixedRate: 0,
    unfixedRate: 23900,
    fixedDays: 0,
    unfixedDays: 480,
    currentCalculatedRate: 23900,
    previousCalculatedRate: null,
    trend: null,
    trendPercentage: null,
  },
]
